import clsx from 'clsx';
import React from 'react';

import SubmenuNav, { SubmenuNavProps } from '../index';

export type DefaultSubmenuNavProps = SubmenuNavProps & {
  isPro?: boolean;
  position?: 'left' | 'right';
  openOnHover: boolean;
  showLeftDivider?: boolean;
  styledWhenOpen?: boolean;
  variant?: 'small' | 'big';
};

const DefaultSubmenuNav = ({
  className,
  isPro,
  isScrollStyle,
  openOnHover,
  position = 'left',
  variant = 'big',
  styledWhenOpen,
  showLeftDivider,
  submenuClasses,
  ...rest
}: DefaultSubmenuNavProps) => {
  return (
    <SubmenuNav
      className={clsx(
        className,
        'relative border-none py-12 font-suisse-intl-mono text-overline-md transition-colors',
        {
          'after:absolute after:bottom-0 after:left-0 after:h-2 after:w-full after:transition-colors after:content-[""]':
            styledWhenOpen || isPro,
          'before:absolute before:-left-36 before:bottom-0 before:h-px before:w-36 before:origin-bottom-right before:rotate-[50deg] before:bg-black before:content-[""]':
            showLeftDivider,
          'px-10 py-[22px] text-white': isScrollStyle,
          'px-16': !isScrollStyle,
        }
      )}
      openMenuClasses={clsx({
        '!text-primary-magenta after:bg-primary-magenta': styledWhenOpen,
        '!text-pro-gold after:bg-pro-gold': isPro && isScrollStyle,
      })}
      submenuClasses={clsx(
        'absolute bg-grayscale-charcoal text-white',
        {
          'right-0 w-[315px] ': position === 'right',
          'h-auto': position === 'left',
          'px-28 pb-24 pt-36': variant === 'small',
          'px-48 py-24': variant === 'big',
        },
        submenuClasses
      )}
      openOnHover={openOnHover}
      isScrollStyle={isScrollStyle}
      {...rest}
    />
  );
};

export default DefaultSubmenuNav;
